var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"py-1 px-2 rounded-lg white--text",class:_vm.statusBackgroundColor,staticStyle:{"font-size":"12px"}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }